import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgAppApiBuilderFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M3 5v14l5 2V3L3 5ZM21 5v14l-5 2V3l5 2ZM13.5 19.68h-3v-2h3v2ZM10.5 6.32h3v-2h-3v2Z"
    />
  </svg>
);
export default SvgAppApiBuilderFill;
